module.exports = __webpack_public_path__ + "static/lila-bud3-7b84daf347b21a37a22f8d13475132b8.mp4";